import axios from "axios";
import React, { useState } from "react";
import { BASEURL } from "../../../utils/BaseUrl";
import { useParams, useNavigate } from "react-router-dom";
import TraingleLoading from "../../../common/Loading/TraingleLoading";
import Swal from "sweetalert2";

const ConformPassword = () => {
  const [conformdata, setConformData] = useState({
    newpassword: "",
    conformpassword: "",
    newpasswordStatus: "unchecked",
    conformpasswordStatus: "unchecked",
  });
  const [isloading, setIsloading] = useState(false);
  const navigate = useNavigate();

  const { token } = useParams();

  const handleChange = (e) => {
    let newdata = { ...conformdata };
    if (e.target.name == "newpassword") {
      const allCharactersLengthRegex = new RegExp("^.{8,15}$");
      if (allCharactersLengthRegex.test(e.target.value?.trim())) {
        newdata[e.target.name + "Status"] = "success";
      } else {
        newdata[e.target.name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    } else if (e.target.name == "conformpassword") {
      if (conformdata.newpassword == e.target.value) {
        newdata[e.target.name + "Status"] = "success";
      } else {
        newdata[e.target.name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
    }
    newdata[e.target.name] = e.target.value;
    setConformData(newdata);
  };
  const checkSubmit = () => {
    let status = true;

    if (conformdata.newpasswordStatus == "success") {
      status = false;
    } else {
      status = true;
    }
    return status;
  };

  const handleClick = async (e) => {
    e.preventDefault();
    setIsloading(true);
    const response = await axios
      .post(
        `${BASEURL}reset-password`,
        {
          password: conformdata.newpassword,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        Swal.fire({
          title: "Reset yout password",
          icon: "success",
          draggable: false,
          // confirmButtonColor:"#fcd70c",
          customClass: {
            confirmButton: "custom-confirm-button", // Add a custom class for styling
          },
        }).then(() => {
          navigate("/admin")
        });
      })
      .finally(() => {
        setIsloading(false);
      });
  };
  return (
    <div className="w-full h-screen flex items-center justify-center">
      {isloading && <TraingleLoading />}
      <div class="form-container">
        <div class="logo-container">Conform Password</div>

        <form class="form">
          <div class="form-group my-2">
            <label for="email">New Password</label>
            <input
              type="text"
              value={conformdata.newpassword}
              className={`${
                conformdata.newpasswordStatus == "success"
                  ? "input-success"
                  : conformdata.newpasswordStatus == "error"
                  ? "input-error"
                  : ""
              }
              `}
              id="email"
              name="newpassword"
              placeholder="New password"
              onChange={(e) => handleChange(e)}
            />
            {conformdata.newpasswordStatus == "error" && (
              <p className="text-sm font-semibold text-speed-red">
                A password should be at least 8 characters
              </p>
            )}
          </div>
          {/* <div class="form-group  my-2">
            <label for="email">Conform New Password</label>
            <input
              type="text"
              value={conformdata.conformpassword}
              className={`    ${
                conformdata.conformpasswordStatus == "success"
                  ? "input-success"
                  : conformdata.conformpasswordStatus == "error"
                  ? "input-error"
                  : ""
              }`}
              id="email"
              name="conformpassword"
              placeholder="Conform Password"
              onChange={(e) => handleChange(e)}
            />
            {conformdata.conformpasswordStatus == "error" && (
              <p className="text-sm font-semibold text-speed-red">
                conformpassword does not match
              </p>
            )}
          </div> */}

          <button
            class={`signbutton my-3 
         ${checkSubmit() ? "cursor-not-allowed" : "cursor-pointer"}
            `}
            type="submit"
            // disabled={checkSubmit()}
            onClick={(e) => handleClick(e)}
          >
            Conform
          </button>
        </form>
      </div>
    </div>
  );
};

export default ConformPassword;
